import { GridLegacy as Grid, Typography } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { WidgetSettings } from '../../../../userSettings';
import { myWorkspaceWidgetsMap } from '../../../Widgets/data';

import { ManageDeleteAndAndVisibility } from './components/ManageDeleteAndVisibility';
import { useSxStyles } from './useStyles';

export interface Props {
  settings: WidgetSettings;
}

export const ManageWidgetMenu: React.FC<Props> = ({ settings }) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  const widget = myWorkspaceWidgetsMap[settings.widget];

  return (
    <>
      <Grid container sx={sxStyles.containerTopMask}></Grid>
      <Grid container sx={sxStyles.containerTop}>
        <Grid item sx={sxStyles.title}>
          <Typography sx={sxStyles.titleContent}>{t(widget.title)}</Typography>
        </Grid>
      </Grid>
      <Grid sx={sxStyles.containerBottom}>
        <ManageDeleteAndAndVisibility settings={settings} />
      </Grid>
    </>
  );
};
